const state = {
  productosData: [
    {
      id: 1,
      id_categoria: 2,
      categoria: 'quimicos',
      codigo: 20001,
      descripcion: 'Jabón más color en bidón.',
      detalle: 'Jabón para ropa de color.',
      unidad: 'bidon',
      favorited: 1,
      imagen: '',
      stock: 20,
      precio_compra: 0.0,
      precio_venta: 258.0,
      ventas: 0,
      fecha: '2021-04-15 14:50:53'
    },
  ],
};

const getters = {
  demoProductos: state => state.productosData,
  getProductoByCodigo: (state) => (codigo) =>{
    return state.productosData.find(producto=>producto.codigo == codigo);
  },
};

export default{
  state,
  getters
}